module.exports = __webpack_public_path__ + "static/activityIcon3.336bf4ce.png";